<template>
  <!--  @click="showRelated =false" -->
  <div>
    <div class="banners">
      <div class="banners-box">
        <div class="banners-box-input_box">
          <!--  @click.stop="showRelated =!showRelated" -->
          <!-- <div> -->
          <el-input
            v-model.trim="search"
            :placeholder="placeholder"
            class="search"
            @keyup.enter.native="searchBtn"
            @focus="getFocus"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="searchBtn"
            ></i>
          </el-input>
          <!-- </div> -->
          <ul class="wordsList" v-show="showRelated == true">
            <li v-for="item in words_list" @click="hotSearch(item)">
              {{ item }}
            </li>
          </ul>
        </div>
        <ul class="keyWord">
          <li v-for="item in hotwords_list" @click="hotSearch(item)">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div class="main-content">
        <div class="content-l">
          <div class="dropdown">相关文章</div>
          <div class="content-list">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="bigBox"
              @click="detail(item)"
            >
              <div class="list-box">
                <div class="img">
                  <img
                    :src="item.content.cover_url"
                    alt
                    v-if="typeof item.content.cover_url == 'string'"
                  />
                  <img :src="item.content.cover_url[0]" alt v-else />
                  <!-- 音频 -->
                  <img
                    src="@/assets/img/icon_voice.png"
                    alt
                    class="voiceImg"
                    v-if="item.content.article_type == 'sound'"
                  />
                </div>
                <div class="suggest">
                  <p>{{ item.content.title }}</p>
                  <div class="message">
                    <div>
                      {{ item.content.visit_times }}
                      <span>阅读</span>
                    </div>
                    <div class="time">
                      {{ item.content.publish_at | timefilters }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="list.length <= 0" class="noData">暂无相关文章</div>
          </div>
          <div class="morePage" v-if="show_page">
            <div @click="moreData">
              <p>加载更多资讯</p>
              <div>
                <img src="@/assets/img/more.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <!-- 相关标签 -->
          <div class="right-box">
            <div class="laber-list">
              <h3>相关标签</h3>
              <ul>
                <li v-for="(item, i) in laberList" :key="i">
                  <p @click="goLaber(item)">#{{ item.content.name }}</p>
                </li>
              </ul>
              <div v-if="laberList.length <= 0" class="rightNoData">
                暂无相关标签
              </div>
            </div>
          </div>
          <!-- 相关栏目 -->
          <div class="right-box">
            <div class="column-list">
              <h3>相关栏目</h3>
              <ul>
                <li
                  v-for="(item, i) in columnList"
                  :key="i"
                  @click="goColumn(item)"
                >
                  <div v-if="item.content.hasOwnProperty('parent_column')">
                    /{{ item.content.name }}
                  </div>
                  <p v-else>
                    <img
                      :src="item.content.selected_mini_icon"
                      alt
                      style="width:20px;vertical-align: middle;"
                    />
                    {{ item.content.name }}
                  </p>
                </li>
              </ul>
              <div v-if="columnList.length <= 0" class="rightNoData">
                暂无相关栏目
              </div>
            </div>
          </div>
          <!-- 相关单行本 -->
          <div class="right-box">
            <div class="single-list">
              <h3>相关单行本</h3>
              <ul>
                <li
                  v-for="(item, i) in singleList"
                  :key="i"
                  @click="goSubject(item)"
                >
                  <div class="single">
                    <div class="img">
                      <img :src="item.content.cover_url" alt />
                    </div>
                    <div class="single-cont">
                      <div>{{ item.content.name }}</div>
                      <p>{{ item.content.articles_count }}篇文章</p>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-if="singleList.length <= 0" class="rightNoData">
                暂无相关单行本
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHotwords, getSearch } from "@/api/search";
import { getTdkList} from "@/api/tdk";

export default {
  data() {
    return {
      placeholder: "搜索文章、标签、栏目、单行本、音频",
      hotwords_list: {},
      show_page: true,
      page: 1,
      per: 8,
      search_type: ["article", "topic", "subject", "column"],
      search: "",
      list: [],
      // 相关标签
      laberList: [],
      columnList: [],
      singleList: [],
      words_list: [],
      showRelated: false,
      init_flag: true
    };
  },
  methods: {
    moreData() {
      this.getSearchList(0);
    },
    goSubject(scope) {
      if (scope.content.is_jurisdiction) {
        this.$router.push({
          name: "read_free",
          params: {
            id: scope.content.id,
            type: scope.content.type,
            cover: scope.content.cover_url,
            title: scope.content.name,
            time: scope.content.display_time
          }
        });
      } else {
        this.$router.push({
          name: "read_detail",
          params: { id: scope.content.id }
        });
      }
    },
    goLaber(scope) {
      this.$router.push({
        name: "hot_laber",
        params: {
          name: scope.content.name,
          id: scope.content.id,
          isSearch: false,
          type: "undefined"
        }
      });
    },
    goColumn(scope) {
      this.$router.push({
        name: "hot_laber",
        params: { id: scope.content.id, type: "magazine", isSearch: false }
      });
    },
    hotSearch(hotwords) {
      this.search = hotwords;
      this.showRelated = false;
      this.searchBtn();
    },
    searchBtn() {
      if (this.search != "" && this.init_flag) {
        this.init_flag = false;

        this.$router.push({
          name: "search",
          params: { keyword: this.search }
        });
        this.placeholder = "搜索文章、标签、栏目、单行本、音频";
        this.searchWords(this.search);
        this.page = 1;
        this.list = [];
        this.show_page = true;
        this.getSearchList(0);
        this.getSearchList(1);
        this.getSearchList(2);
        this.getSearchList(3);
      } else {
        this.placeholder = "请输入搜索内容...";
      }
    },
    searchWords(data) {
      if (
        localStorage.getItem("words_list") != "" &&
        localStorage.getItem("words_list") != null
      ) {
        this.words_list = JSON.parse(localStorage.getItem("words_list"));
        if (this.words_list.indexOf(data) >= 0) {
          this.words_list.splice(this.words_list.indexOf(data), 1);
        }

        this.setWords();
      }
      this.words_list.push(data);
      localStorage.setItem("words_list", JSON.stringify(this.words_list));
    },
    setWords() {
      if (this.words_list.length >= 6) {
        this.words_list.splice(0, 1);
        this.setWords();
      }
    },
    // 获取焦点
    getFocus() {
      this.showRelated = true;
    },
    // 文章详情
    detail(scope) {
      this.resetSetItem("isActive", 0);
      if (
        scope.content.article_type == "sound" ||
        scope.content.article_type == "voice"
      ) {
        this.$router.push({
          name: "hot_detail",
          params: { id: scope.content.id, isSearch: true, keyWord: this.search }
        });
      } else {
        this.$router.push({
          name: "article_detail",
          params: {
            id: scope.content.id,
            isSearch: true,
            keyWord: this.search,
            isRead: false
          }
        });
      }
    },
    getKeywordsList() {
      getHotwords().then(res => {
        this.hotwords_list = res.data.data;
      });
    },
    getSearchList(index) {
      if (index == 0) {
        var params = {
          page: this.page,
          per: this.per,
          query: this.search,
          query_type: this.search_type[index],
          type: "android"
        };
      } else {
        var params = {
          query: this.search,
          query_type: this.search_type[index],
          type: "android"
        };
      }
      getSearch(params).then(res => {
        if (index == 0) {
          this.init_flag = true;
          if (this.page == 1) {
            this.list = res.data.data;
          } else {
            this.list = this.list.concat(res.data.data);
          }
          if (this.page >= res.data.meta.total_pages) {
            this.show_page = false;
          } else {
            this.page++;
          }
        } else if (index == 1) {
          this.laberList = res.data.data;
        } else if (index == 2) {
          this.singleList = res.data.data;
        } else if (index == 3) {
          this.columnList = res.data.data;
        }
      });
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })

    this.search = this.$route.params.keyword;
    this.$ba([["plabel", "search"],['searchkey',this.search]]);
    this.getKeywordsList();
    this.searchBtn();
  },
  mounted() {
    document.addEventListener("click", e => {
      var name = e.target.className;
      if (name != "el-input__inner") {
        this.showRelated = false;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.banners {
  background: url("../assets/img/bg_serch.png") no-repeat;
  height: 300px;
  margin-top: 73px;
  .banners-box {
    height: 100%;
    width: 100%;
    position: relative;
    .banners-box-input_box {
      width: 36%;
      position: absolute;
      top: 46%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      .wordsList {
        width: 100%;
        background: #fff;
        position: absolute;
        top: 80%;
        li {
          padding: 10px 20px;
          border-bottom: 1px solid #eee;
          cursor: pointer;
        }
        li:hover {
          background: #d3d3d3;
        }
      }
      .search {
        width: 100%;
        margin: 0 auto;
        transform: translate(-50%, -50%);
        position: relative;
        top: 50%;
        left: 50%;
        >>> .el-input__inner {
          border-radius: 0 !important;
          outline: 0;
          border: 0;
        }
        >>> .el-input__icon {
          cursor: pointer;
          font-size: 22px;
          color: #000;
          margin-right: 20px;
        }
      }
    }
  }
  .keyWord {
    justify-content: center;
    position: relative;
    top: 50%;
    text-align: center;
    display: flex;
    color: #fff;
    cursor: pointer;
    li {
      padding: 0 20px;
    }
    li:hover {
      text-decoration: underline;
    }
  }
}
.content-r {
  margin-bottom: 60px;
}
.dropdown {
  background: #ffffff;
  font-size: 16px;
  margin-top: 30px;
  padding: 12px 30px;
  font-weight: bold;
}
.content-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 60px;
  .bigBox {
    display: inline-block;
    width: 48%;
    cursor: pointer;
    .list-box {
      background: #fff;
      margin-top: 30px;
      .img {
        width: 100%;
        height: 230px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          vertical-align: bottom;
        }
        .voiceImg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: auto;
          height: auto;
        }
      }
      .suggest {
        padding: 26px 30px 20px 30px;
        p {
          font-size: 20px;
          min-height: 60px;
          line-height: 30px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 12px;
          text-align: justify;
        }
        .message {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: #999999;
          .time {
            margin-right: 24px;
          }
        }
      }
    }
  }
  .noData {
    margin-top: 20px;
    width: 100%;
    background: #fff;
    text-align: center;
    line-height: 300px;
  }
}
.right-box {
  background: #ffffff;
  margin-top: 30px;
  .laber-list {
    h3 {
      font-size: 16px;
      line-height: 46px;
      padding: 0 30px;
      border-bottom: 1px solid #eeeeee;
    }
    ul {
      padding: 26px 30px 10px 30px;
      li {
        color: #0091ff;
        font-size: 18px;
        margin-bottom: 16px;
        cursor: pointer;
      }
    }
  }
  .column-list {
    h3 {
      font-size: 16px;
      line-height: 46px;
      padding: 0 30px;
      border-bottom: 1px solid #eeeeee;
    }
    ul {
      padding: 20px 30px 20px 30px;
      li {
        font-size: 18px;
        cursor: pointer;
        p {
          line-height: 36px;
          span {
            width: 20px;
            height: 20px;
            line-height: 17px;
            border-radius: 50%;
            background: #000;
            color: #fff;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            margin-right: 4px;
            font-size: 14px;
            font-weight: 600;
          }
        }
        div {
          color: #999999;
          line-height: 36px;
        }
      }
    }
  }
  .single-list {
    h3 {
      font-size: 16px;
      line-height: 46px;
      padding: 0 30px;
      border-bottom: 1px solid #eeeeee;
    }
    ul {
      padding: 20px 30px 20px 30px;
      li {
        font-size: 18px;
        cursor: pointer;
        margin-bottom: 20px;
        .single {
          display: flex;
          .img {
            width: 47%;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .single-cont {
            width: 47%;
            line-height: 30px;
            div {
              font-size: 20px;
              margin-bottom: 10px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            p {
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }
  }
}
.rightNoData {
  width: 100%;
  background: #fff;
  text-align: center;
  line-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/search.vue